module.exports = __webpack_public_path__ + "open-sans-v17-latin-regular.woff2?33543c5cc5d88f5695dd08c87d280dfd";